var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "global-footer-sns-account-block" }, [
      _c("div", { staticClass: "global-footer-sns-account-inr" }, [
        _c("p", { staticClass: "global-footer-sns-account-txt" }, [
          _vm._v("@cosme "),
          _c("span", [_vm._v("公式SNSアカウント")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "global-footer-sns-icon-area" }, [
          _c("ul", { staticClass: "global-footer-sns-icon-list" }, [
            _c("li", [
              _c(
                "a",
                {
                  staticClass:
                    "global-footer-sns-icon global-footer-icon-instagram",
                  attrs: {
                    href: "https://www.instagram.com/at_cosme/",
                    target: "_blank",
                  },
                },
                [_vm._v("instagram")]
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "global-footer-sns-icon global-footer-icon-x",
                  attrs: {
                    href: "https://twitter.com/atcosmenet",
                    target: "_blank",
                  },
                },
                [_vm._v("x")]
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                {
                  staticClass:
                    "global-footer-sns-icon global-footer-icon-facebook",
                  attrs: {
                    href: "https://www.facebook.com/atcosme/",
                    target: "_blank",
                  },
                },
                [_vm._v("facebook")]
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "global-footer-sns-icon global-footer-icon-line",
                  attrs: {
                    href: "https://line.me/R/ti/p/%40at_cosme",
                    target: "_blank",
                  },
                },
                [_vm._v("line")]
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }